import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import PasswordForm from '@/modules/auth/components/FormsContainer/Password/PasswordForm';
import Header from '@/modules/auth/components/Header';
import { useAuth } from '@/shared/hooks/context/auth';

const ResetPassword = () => {
  const { t } = useTranslation('login');
  const { query } = useRouter();
  const { login } = useAuth();

  useEffect(() => {
    if (query && query.token) {
      login(query.token as string, undefined, 1727202181651);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  return (
    <div className='flex flex-col gap-16'>
      <Header title={t('reset-your-password')} />
      <PasswordForm type='reset' />
    </div>
  );
};

export default ResetPassword;
